// extracted by mini-css-extract-plugin
export var card = "_le-0";
export var content = "_le-2";
export var details = "_le-3";
export var icon = "_le-1";
export var iconBlue = "_le-5";
export var iconBrand = "_le-4";
export var iconGrayBlue = "_le-6";
export var iconGreen = "_le-7";
export var iconIndigo = "_le-8";
export var iconOrange = "_le-9";
export var iconPurple = "_le-a";
export var iconRed = "_le-b";
export var iconWarning = "_le-c";